(function($) {
  'use strict';
  $(function() {
    $('[data-toggle="offcanvas"]').on("click", function() {
      $('.sidebar-offcanvas').toggleClass('active');
        console.log('hello world');
    });
  });
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/routes/admin/partials/off-canvas.js